export enum SummaryStatus {
  INIT = "init",
  PROCESSING = "processing",
  PROCESSED = "processed"
}
